export default __webpack_public_path__ + "static/media/work-order-key.c387bab8.svg";